import { render, staticRenderFns } from "./CandidateVolumnOTM.vue?vue&type=template&id=5a9f0196"
import script from "./CandidateVolumnOTM.vue?vue&type=script&lang=js"
export * from "./CandidateVolumnOTM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports